<template>
  <div class="page-container">
    <div class="query-title">签约完成情况查询</div>

    <div class="content">
      <QueryParams ref="QueryParams" :loading="loading" :search-field="searchField" @search="queryData" />
      <div class="table-container">
        <Table-filter
          title="明细"
          :rt-columns="rtColumns1"
          :lt-columns="ltColumns1"
          :grid-columns="gridOptions.columns"
          :count-data="countFileds"
          :all-options="allOptions"
          :pagination="pagination"
          @pagination-change="handleTablePaginationChange"
          @confirm="tableConfigConfirm"
        >
          <template #button>
            <table-button name="export" tip="导出数据" @click="exportExcel" />
          </template>
          <vxe-grid
            ref="xTable"
            v-loading="loading"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            height="300"
            max-height="600"
            align="center"
            size="mini"
            show-overflow
            :checkbox-config="{ highlight: true }"
            :radio-config="{ highlight: true }"
            :sort-config="{ multiple: true }"
            :empty-render="{name: 'NotData'}"
            :filter-config="{ remote: true }"
            :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptions.columns"
            :data="gridOptions.data"
            :row-class-name="rowClassName"
            @filter-change="filterChangeEvt"
          >
            <template #saleCenterName="{ row }">
              <span class="blue" @click="goOrderDetail(row)">{{ row.saleCenterName }}</span>
            </template>
          </vxe-grid>
        </Table-filter>
      </div>
    </div>
    <!-- 明细框 -->
    <el-dialog
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="showDialog"
      width="80%"
      :append-to-body="true"
    >
      <signingCompletedDetail sourceType='completedList' :completedRow="completedRow"/>
      <div slot="footer">
        <el-button type="default" icon="el-icon-circle-close" size="small" @click="showDialog = false">取消</el-button>
        <el-button type="primary" icon="el-icon-circle-check" size="small" @click="showDialog = false">确定</el-button>
      </div>
    </el-dialog>
    <table-custom-filter ref="CustomFilter" :current-filter-field="currentFilterField" @confirm="customeFilter" />
  </div>
</template>

<script>
import { Message } from 'element-ui'
import { findSignCompletedQuery} from '@/api/signing'
import {spctOrderPlsp, getCenterFz} from '@/api/sap/signing-sap'
import { apiGetContractList, apiApprove } from '@/api/sap/contract'
import tableMixins from '@/utils/tableMixins'
import pageConfig, { pageSearch } from './config/signingCompleted'
import { frontExport, concurrencyReq } from '@/utils/frontExport'
import { mapGetters } from 'vuex'
import signingCompletedDetail from './signingCompletedDetail.vue'
import { formatWlyYear } from '@/utils/handleFormData'
export default {
  mixins: [tableMixins],
  components: {
    signingCompletedDetail
  },
  data() {
    return {
      completedRow: {},
      dialogTitle: '签约完成明细查看',
      pageSearch,
      searchField: {},
      showDialog: false,
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      loading: false,
      gridOptions: {
        columns: [
          { type: 'checkbox', field: 'checkbox', title: '', width: 40 }
        ],
        data: []
      },
    }
  },
  props: {
  },
  created() {
    const currentYear= formatWlyYear()
    pageConfig.totalPlanQty.title = currentYear - 1 + '年签约总量(件)'
    pageConfig.totalPlanMoney.title = currentYear - 1  + '年签约总金额(万元)'
    this.initPage(pageConfig)
  },
  methods: {
    async submitHandle(){
    },
    goOrderDetail(row){
      this.showDialog = true
      this.completedRow = row
    },
    // 导出全部 导出本页
    async exportExcel() {
      const checkData = this.$refs.xTable.getCheckboxRecords()
      if (checkData.length) {
        frontExport(this.gridOptions.columns, checkData, '签约完成情况数据报表')
        return
      }
      const params = {
        user_bp: this.$store.getters.role.USER_BP,
        ...this.allConditions
      }
      const data = await concurrencyReq(this.pagination.totalCount, params, findSignCompletedQuery)
      frontExport(this.gridOptions.columns, data, '签约完成情况数据报表')
    },
    handleTablePaginationChange(pages) {
      Object.assign(this.pagination, pages)
      this.queryData()
    },
    async queryData(page, ranges) {
      if (page === 1) {
        this.pagination.page = page
        if (ranges) {
          // 保存 查询组件的查询参数
          this.ranges = ranges
          this.handleRanges(ranges)
        }
        this.isSetFilter = false
      }
      const params = {
        user_bp: this.$store.getters.role.USER_BP,
        role: this.$store.getters.role.ROLE,
        ...this.pagination,
        is_result: 1,
        // sort: this.sortData.concat(this.tableSort),
        ...this.allConditions,
      }
      this.loading = true
      try {
        const { data: { Rows, Total }, calculation, field } = await findSignCompletedQuery(params)
        if (Rows.length === 0 && (Total - 0)) {
          this.queryData(1, ranges)
          return
        }
        this.pagination.totalCount = Total - 0
        this.calculation = this.filtercalculation(calculation, 'xTable', true)
        // 更新计算值
        this.updateCount()
        if (this.showHeader) {
          this.gridOptions.data = this.tableCountData.concat(Rows)
        } else {
          this.gridOptions.data = Rows.concat(this.tableCountData)
        }
        this.allOptions = this.filterAllOptions(field, 'xTable', true)
        this.setFilter()
      } catch (e) {
        //
      }
      this.loading = false
    },
  },

}
</script>
<style lang="scss" scoped>
  .blue {
    color: rgb(45, 146, 214);
    cursor: pointer;
  }

</style>



// WEBPACK FOOTER //
// src/views/qy-manage/signingCompleted.vue